module.exports = __webpack_public_path__ + "img/y_2018_hover.20bc2ac3.png";